import { useMemo, useEffect } from 'react';
import AnalyticsService from '@picsart/rc/services/analytics';
import { e as ComponentsOptions, m as AnalyticsScreenNameOptions } from '../constants-e3c79897.js';
import getRegistrationAnalyticsAction from '../getRegistrationAnalyticsAction/index.js';
import { REGISTRATION_OPEN, ANALYTICS_PLATFORM_TYPE } from '../configs/constants/index.js';
import { getRecentLoginMethods } from '../services/recentLoginMethods/index.js';

var TIMEOUT_DELAY = 1000;
var useRegistrationAnalytics = function useRegistrationAnalytics(currentPage, flow, isAuthCombined, triggeredFrom) {
  var methods = useMemo(function () {
    return getRecentLoginMethods();
  }, []);
  useEffect(function () {
    if (currentPage === ComponentsOptions.AccountTermination) {
      return;
    }
    var timeoutId = setTimeout(function () {
      AnalyticsService.sendEvent(REGISTRATION_OPEN, {
        registration_type: 'standard',
        screen_name: AnalyticsScreenNameOptions[currentPage],
        source_page: AnalyticsScreenNameOptions[currentPage],
        action: getRegistrationAnalyticsAction(currentPage),
        action_button: triggeredFrom,
        flow_type: isAuthCombined && 'monetization_combined',
        flow: flow,
        suggested_accounts: methods.map(function (methods) {
          return methods.provider;
        }),
        platform_type: ANALYTICS_PLATFORM_TYPE
      });
    }, TIMEOUT_DELAY);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [currentPage, isAuthCombined, methods, triggeredFrom, flow]);
};

export { useRegistrationAnalytics as default };
//# sourceMappingURL=index.js.map
